import type React from 'react';
import { WizardForm } from '../components/wizard/WizardForm.js';

export const WizardPage: React.FC = () => {
  return <WizardForm />;
};
